<template>
  <PoseTransition>
    <DetailWrapper class="magazine-details" v-if="isVisible">
      <div class="magazine-details__top">
          <BaseButton
            class="magazine-details__close"
            variant="white"
            rounded="full"
            width="small"
            aria-label="Close these details"
            @click="$emit('toggled')"
          >
            <BaseIcon name="close" size="24"></BaseIcon>
          </BaseButton>
        </div>
      <DetailInfo class="magazine-details__block">
        <div class="magazine-details__image-wrapper">
            <figure class="magazine-details__image">
              <img :src="getImage" />
            </figure>
          </div>
        <div class="magazine-details__info">
          <TextProse>
            <div class="magazine-details__title">
              <h2>
                <TextHeading
                  class="magazine-details__title-sub"
                  variant="title"
                  >{{ title }}</TextHeading
                >
              </h2>
            </div>
            <h3>
              <TextHeading color="secondary" variant="magazinetitle">{{
                subtitle
              }}</TextHeading>
            </h3>
            <p>{{ detail }}</p>
            <h3>
              <TextHeading color="secondary" variant="magazinetitle">{{
                subsection
              }}</TextHeading>
            </h3>
          </TextProse>
          <!-- <MagazineDetailsInfo
            v-for="item in items"
            v-bind:data="item"
            v-bind:key="item.id"
          /> -->
          <MagazineButtonBar />
        </div>


     


      </DetailInfo>
      <div @click="$emit('toggled')" class="magazine-details__bkgd"></div>
    </DetailWrapper>
  </PoseTransition>
</template>

<script>
import posed, { PoseTransition } from 'vue-pose'
import MagazineButtonBar from '@/components/MagazineButtonBar.vue'
// import MagazineDetailsInfo from '@/components/MagazineDetailsInfo.vue'
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import TextHeading from '../elements/TextHeading.vue'
import TextProse from '../elements/TextProse.vue'

export default {
  name: 'MagazineDetails',
  components: {
    MagazineButtonBar,
    // MagazineDetailsInfo,
    BaseButton,
    BaseIcon,
    TextHeading,
    TextProse,
    PoseTransition,
    DetailWrapper: posed.div({
      enter: {
        opacity: 1,
        beforeChildren: true,
        transition: { duration: 200, ease: 'linear' },
      },
      exit: {
        opacity: 0,
        afterChildren: true,
        transition: { duration: 200, ease: 'linear' },
      },
    }),
    DetailInfo: posed.section({
      enter: {
        x: '0%',
        opacity: 1,
        transition: { duration: 500, ease: 'easeOut' },
      },
      exit: {
        x: '100%',
        opacity: 0,
        transition: { duration: 300, ease: 'easeOut' },
      },
    }),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Detail title goes here',
    },
    subtitle: {
      type: String,
      default: 'Description',
    },
    detail: {
      type: String,
      default:
        'Matured for 30 days for flavour. Perfect served hot for lunch or dinner, or enjoyed cold on a buffet with chutney.',
    },
    subsection: {
      type: String,
      default: 'Preparation and Safety',
    },
    image: {
      type: String,
      default: 'christmas-highlight-1.jpg',
    },
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    },
  },
  data() {
    return {
      items: [
        {
          subtitle: 'Cooking instructions',
          text: 'Medium – 50 minutes - 1 hour 20 minutes',
        },
        {
          subtitle: 'Ingredients',
          text: 'British Beef (100%)<br>Nutritional & Allergy Information.',
        },
        {
          subtitle: 'Dietry Information',
          text: 'Reference intake of an average adult (8400 kJ / 2000 kcal)<br>Per serving based on 165g portion',
        },
        {
          subtitle: 'Country of Origin',
          text: 'Produced in the United Kingdom using British beef.',
        },
      ],
    }
  },
}
</script>

<style lang="postcss">
.magazine-details {
  @apply fixed inset-0 flex justify-end items-start text-white z-100000;
  -webkit-backface-visibility: hidden;
}
.magazine-details__bkgd {
  @apply absolute p-2 h-screen w-screen bg-body opacity-75 inset-0;
}
.magazine-details__block {
  @apply flex flex-col bg-white w-full z-100 mx-auto h-screen p-0;
  box-shadow: 0px 0px 3px 2px rgba(0,0,0,0.3);
}
.magazine-details__top {
  @apply absolute right-0 top-0 z-100000;
}
.magazine-details__close {
  @apply text-primary m-2 flex items-center justify-center;
}
.magazine-details__info {
  @apply flex-1  overflow-y-auto p-4;
  -webkit-backface-visibility: hidden;
}
.magazine-details__info .prose,
.magazine-details__info .prose p {
  @apply text-body;
}
.magazine-details__image-wrapper {
  @apply overflow-hidden bg-primary flex-1;
}
.magazine-details__image {
  @apply h-full bg-body relative overflow-hidden;
}
.magazine-details__image img {
  /* @apply block  object-contain h-full object-center opacity-50; */
   @apply block absolute inset-y-0 inset-x-0 object-contain mx-auto object-center h-full; 
}
.magazine-details__title {
  @apply mb-3;
}
.magazine-details__title-sub {
  @apply text-body;
}

@screen sm {
  .magazine-details {
  @apply px-4;
  }

  .magazine-details__block {
    @apply w-full max-w-4xl flex-row mx-auto rounded-lg h-auto  p-4 shadow-lg;
    max-height: 60vh;
    margin-top:20vh;
  }
  .magazine-details__image-wrapper {
  border-radius:0.3rem;
}
.magazine-details__image img {
  /* @apply block  object-contain h-full object-center opacity-50; */
   @apply block absolute inset-y-0 inset-x-0 object-cover object-center h-full; 
}
.magazine-details__close {
    @apply text-primary m-4 flex items-center justify-center;;
  }
  .magazine-details__info {
    @apply pl-4;
  }
}
</style>
